import { Component } from 'react';
import { connect } from 'react-redux';
import { Checkbox } from 'informed';

const Switch = connect((state) => ({ theme: state.theme }))(
  class extends Component {
    handleClick = (ev) => {
      ev.stopPropagation();
    };

    render() {
      const {
        darkMode,
        dispatch,
        error,
        field,
        id,
        label,
        labelBefore,
        labelProps,
        labelStyle,
        size = 'medium',
        stopPropagation,
        style,
        theme,
        ...params
      } = this.props;

      let color = 'rgba(0, 0, 0, 0.1)';
      let iconColor = theme.successTextColor;
      let activeColor = theme.successColor;
      let outlineColor = 'rgba(0, 0, 0, 0.15)';
      let labelColor = theme.textColorLight;
      if (darkMode) {
        color = 'rgba(255, 255, 255, 0.5)';
        iconColor = theme.successTextColorDark;
        activeColor = theme.successColorDark;
        outlineColor = 'rgba(255, 255, 255, 0.2)';
        labelColor = '#fff';
      }

      let iconSize = 14;
      let labelFontSize = '1.5rem';

      if (size === 'small') {
        iconSize = 12;
        labelFontSize = '1.4rem';
      } else if (size === 'large') {
        iconSize = 18;
        labelFontSize = '1.8rem';
      } else if (size === 'huge') {
        iconSize = 22;
        labelFontSize = '2.2rem';
      }

      return (
        <div
          className="switch"
          style={style}
          {...(stopPropagation ? { onClick: this.handleClick } : {})}
        >
          <Checkbox {...params} field={field} id={id} />
          <label htmlFor={id} {...labelProps}>
            {labelBefore ? (
              <div className="text-before" style={labelStyle}>
                {labelBefore}
              </div>
            ) : null}
            <div className="content">
              <div className="inner" />
            </div>
            {label ? (
              <div className="text" style={labelStyle}>
                {label}
              </div>
            ) : null}
          </label>

          {error ? <div className="error-message">{error}</div> : null}

          <style jsx>{`
            .switch {
              line-height: normal;
              position: relative;
            }
            .switch > :global(input) {
              opacity: 0;
              overflow: hidden;
              position: absolute;
              height: 0.1px;
              width: 0.1px;
              z-index: -1;
            }
            .switch > :global(input + label) {
              align-items: flex-start;
              color: ${labelColor};
              cursor: pointer;
              display: flex;
              font-size: ${labelFontSize};
              font-weight: 400;
              position: relative;
              white-space: normal;
              width: auto;
              word-wrap: break-word;
            }
            .switch > :global(input + label .content) {
              background-color: ${color};
              border-radius: 20px;
              display: inline-block;
              flex-shrink: 0;
              font-weight: 400;
              padding: 2px;
              position: relative;
              transition: background-color 0.3s;
              height: ${iconSize + 6}px;
              width: ${iconSize * 2 + 6}px;
            }
            .switch > :global(input + label .inner) {
              background-color: rgba(0, 0, 0, 0.2);
              border-radius: 20px;
              display: inline-block;
              position: absolute;
              top: 3px;
              left: 3px;
              transition: all 0.3s;
              height: ${iconSize}px;
              width: ${iconSize}px;
            }
            .switch > :global(input + label .text) {
              margin-left: 5px;
            }
            .switch > :global(input + label .text-before) {
              margin-right: 5px;
            }
            .switch > :global(input + label:hover .inner) {
              background-color: rgba(0, 0, 0, 0.3);
            }
            .switch > :global(input:checked + label .content) {
              background-color: ${activeColor};
            }
            .switch > :global(input:checked + label .inner) {
              background-color: ${iconColor};
              left: 50%;
            }
            .switch > :global(input:disabled + label) {
              cursor: default;
              opacity: 0.5;
            }
            .switch > :global(input:disabled + label:hover .icon) {
              color: transparent;
            }
            .switch > :global(input:disabled:checked + label:hover .icon) {
              color: ${iconColor};
            }
            .switch > :global(input:focus + label .content),
            .switch > :global(input:focus:checked + label .content) {
              box-shadow: 0 0 0 5px ${outlineColor};
            }
            .error-message {
              color: ${theme.dangerColor};
              font-size: 1.3rem;
              padding: 3px;
            }
          `}</style>
        </div>
      );
    }
  }
);

export default Switch;
